import { useEffect } from 'react';
import { useActivePractice, useDispatch } from '@witmetrics/data-store';
import { useAppState } from '@/providers/AppStateProvider';
import { useToggle } from '@/hooks/useToggle';
import Overlay from '@/components/Overlay';
import OrderInfoColumn from './OrderInfoColumn';
import TabsColumn from './TabsColumn';
import { classes, fetchPracticeOrderData } from './utils';

export default function PracticeOrderOverlay() {
  const dispatch = useDispatch();
  const { onApiError, activeOrderId, onClearActiveOrder } = useAppState();
  const activePractice = useActivePractice();
  const [isFetchingData, toggleFetchingData] = useToggle(true);
  const [isFetchingFiles, toggleFetchingFiles] = useToggle(true);
  const [isInfoCollapsed, toggleInfoCollapsed] = useToggle();

  useEffect(() => {
    if (!activeOrderId) return;
    fetchFileData();
    if (activePractice) fetchData();
  }, [activeOrderId]);

  const fetchData = async () => {
    try {
      toggleFetchingData(true);
      const results = await fetchPracticeOrderData(activeOrderId!);
      dispatch.addOrders([results.order]);
      dispatch.addOrderNotes(results.notes);
      dispatch.addOrderKeypoints(results.keypoints);
      toggleFetchingData(false);
    } catch (err) {
      onApiError(err, 'Error fetching order data', () => fetchData());
    }
  };

  const fetchFileData = async () => {
    try {
      toggleFetchingFiles(true);
      // eslint-disable-next-line witmetrics/no-multiline-comments
      /* TODO
      // const results = await fetchProjectFiles(activeProjectId!);
      // dispatch(
      //   dispatchAddUnisonProjectFileCollection(
      //     results.unisonProjectFileCollection
      //   )
      // );
      // dispatch(dispatchSetFileCollectionFiles(results.fileCollectionFiles));
      // dispatch(dispatchSetFileNotes(results.fileNotes));
      // dispatch(dispatchSetFileCollections(results.fileCollections));
       */
      toggleFetchingFiles(false);
    } catch (err) {
      onApiError(err, 'Error fetching files', () => fetchFileData());
    }
  };

  if (!activeOrderId) return null;

  return (
    <Overlay className={classes.overlay} onClose={onClearActiveOrder}>
      <OrderInfoColumn
        isFetchingData={isFetchingData}
        collapsed={isInfoCollapsed}
        onToggleCollapsed={toggleInfoCollapsed}
      />
      <TabsColumn isFetchingData={isFetchingData} />
    </Overlay>
  );
}
